export enum EmailTemplateType {
    Verification = 'verification',
    Magicsession = 'magicsession',
    Recovery = 'recovery',
    Invitation = 'invitation',
    Mfachallenge = 'mfachallenge',
    Sessionalert = 'sessionalert',
    Otpsession = 'otpsession',
}